<template>
  <div class="lc-badge">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import '../styles/variables';

@mixin badge-variant(
  $background,
  $color: $white-15,
  $focus: rgba($background, $focus-shadow-opacity),
  $hover-background: lighten($background, 6%),
  $hover-border: lighten($background, 6%),
  $active-background: darken($background, 6%),
  $active-border: darken($background, 6%)
) {
  color: $color;
  background-color: $white-15;

  @at-root {
    a#{&} {
      &:hover {
        color: $color;
        background-color: $hover-background;
        border-color: $hover-border;
      }

      &:focus,
      &.focus {
        outline: none;
        box-shadow: 0 0 0 $focus-shadow-width $focus;
      }
    }
  }
}

.lc-badge {
  @include badge-variant(mix($teal, $white, 10%), $teal);

  display: inline-flex;
  align-items: center;
  gap: 0.125rem;
  line-height: 1;
  padding: 0.25rem 0.25rem;
  border-radius: $border-radius;
  font-size: 0.75rem;
  font-weight: 500;

  svg {
    fill: currentColor;
    width: 1rem;
    height: 1rem;
  }
}
</style>
